import requestDefault from '@/shared/utils/request';

// 刷新用户额度以及还款计划数据，并返回额度是否发生变更
export const refreshCreditAndRepayPlan = (
  productId = '',
): Promise<{
  // 额度是否发生变化，包括：授信状态 & 授信额度
  isCreditUpdated: boolean;
}> => requestDefault.postGate(
  'f.loan.bill.refreshUserAndPlan',
  {
    productId,
  },
  {
    showLoading: undefined,
  },
);

const BillAPI = {
  refreshCreditAndRepayPlan,
};

export default BillAPI;
